exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0fc236d8] .el-divider__text{font-weight:700;font-size:16px}[data-v-0fc236d8] .el-card__body{height:100%;padding-bottom:0!important}[data-v-0fc236d8] .withbutton-height{height:calc(100% - 50px)}[data-v-0fc236d8] .nobutton-height{height:calc(100% - 10px)}.custom-title[data-v-0fc236d8]{color:var(--textColor)}[data-v-0fc236d8] .upload-label .el-form-item{margin-left:180px!important}[data-v-0fc236d8] .upload-label .el-form-item__label{float:none!important}[data-v-0fc236d8] .upload-label .el-form-item__content{margin-left:0!important}", ""]);

// exports
